import { Modul } from "./Modul";
export class ModList {
	static listOfModules: any[] = [];
	static listOfSelectedModules: any[] = [];
	static selectedPanels: any[] = [];
	static currentSelectedPanel: any = null;
	static listOfGroups: any = [];
	// public static dicMod: Dictionary = new Dictionary();
	public static iCount: number;
	public static add(o: Modul): void {
		// ModList.dicMod[o] = o;
		ModList.iCount++;
	}
	public static removeSelection(panel?: any) {
		ModList.currentSelectedPanel.on('mousedown', (e: any) => {
			e.cancelBubble = false;
		});
		ModList.currentSelectedPanel.setDraggable(false);
		const a = ModList.currentSelectedPanel.find('.border');
		if (a && a[0]) a[0].opacity(0);
		ModList.currentSelectedPanel = panel ? panel : null;
	}

	public static getPower(): number {
		var nSum: number = 0;
		// nSum = ModList.iCount * SC_Input.nModLeistung;
		return nSum;
	}
	public static getPowerInWp(): string {
		var nSum: number;
		nSum = ModList.getPower();
		return "" //this.NumForm.num2comma(nSum) + " Wp";
	}

	public static getPowerInKWp(): string {
		var nSum: number;
		nSum = ModList.getPower() / 1000;
		return "" //this.NumForm.num2comma(nSum) + " kWp";
	}
}